var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("span", { staticClass: "el-style attribute-name" }, [
      _vm._v("Message:"),
    ]),
    _vm._v(" "),
    _c("div", {
      staticClass: "message message-body",
      domProps: { textContent: _vm._s(_vm.message) },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }